import { useTranslations } from 'next-intl'
import { useCallback } from 'react'

import type {
  InvoiceDeliveryStatus,
  InvoiceReadinessIssue,
  InvoiceRecipientSource,
  InvoiceReviewHoldReason
} from '~/data/api/hooks/billing/invoiceReview'

/** Human label for a problem the readiness check found on an invoice before issuing it. */
export function useInvoiceReadinessIssueFormatter() {
  const t = useTranslations('data.billing')
  return useCallback((issue: InvoiceReadinessIssue) => t(`invoiceReadinessIssue_${issue}`), [t])
}

/** Short label for why an invoice is held for review, as shown on its status chip. */
export function useInvoiceReviewHoldReasonFormatter() {
  const t = useTranslations('data.billing')
  return useCallback((reason: InvoiceReviewHoldReason) => t(`invoiceReviewHoldReason_${reason}`), [t])
}

/** Where the recipients of an invoice email were found. */
export function useInvoiceRecipientSourceFormatter() {
  const t = useTranslations('data.billing')
  return useCallback((source: InvoiceRecipientSource) => t(`invoiceRecipientSource_${source}`), [t])
}

/** Delivery state of the issued-invoice email. */
export function useInvoiceDeliveryStatusFormatter() {
  const t = useTranslations('data.billing')
  return useCallback((status: InvoiceDeliveryStatus) => t(`invoiceDeliveryStatus_${status}`), [t])
}
